import { render, staticRenderFns } from "./SoilMonitor.vue?vue&type=template&id=4d491ef5&scoped=true&"
import script from "./SoilMonitor.vue?vue&type=script&lang=ts&"
export * from "./SoilMonitor.vue?vue&type=script&lang=ts&"
import style0 from "./SoilMonitor.vue?vue&type=style&index=0&id=4d491ef5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d491ef5",
  null
  
)

export default component.exports